import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import '../../fonts/century_751_semi_bold.ttf'; 
import '../../fonts/Weissenhof Grotesk W01 Regular.ttf'; 

import './RulesModal.css';

function RulePolicies(props) {
    return (
        <div>
            <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
          Hotel Rules & Management Policy
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className='modal-body'>
          
          <div>
            <h5>General Booking Policy</h5>
             <ol>
                <li>Policies are booking specific and would be informed to the guest at the time of
                    booking or upon Check-In.
                </li>
                <li>
                    Any extension of stay at the Hotel is subject to availability of the rooms at the
                    current ongoing rate and not at the rate at which the original booking was made.
                </li>
                <li>
                    Hotel allow triple occupancy by providing an extra mattress for the third person for
                    extra fee.
                </li>
             </ol> 
             <h5>Check-in Policy:</h5>
             <ol>
                 <li>
                    The primary guest must be at least 18 years of age to be able to check into the hotel.
                 </li>
                 <li>
                    The usual standard check-in time is 12 noon and Check-out time is 11 AM. The hotel
                    tries to ensure that you can check-in any time after that till your reservation is valid.
                 </li>
                 <li>
                    It is mandatory for all guests to present valid photo identification at the time of
                    check-in. According to government regulations, a valid Photo ID has to be carried by
                    every person above the age of 18 staying at the hotel. The identification proofs
                    accepted are Aadhar Card, Driving License, Voter ID Card, and Passport. Note that
                    PAN card is not acceptable. Without an original copy of a valid ID, you will not be
                    allowed to check-in.
                 </li>
                 <li>
                    Unless specifically intimated, the Hotel shall not be held liable to refund the booking
                    amount or any part thereof in case of unavailability of rooms due to natural disaster
                    (earthquake, landslide etc.), terrorist activity, government guidelines or any force
                    majeure act, beyond the control of the Hotel.
                 </li>
             </ol>
             <h5>Visitors Policy:</h5>
             <ol>
                 <li>Visitors are generally allowed to meet guests in the guest rooms during the day,
                        except if there is an emergency.
                </li>
                 <li>Visitors are not to be allowed to stay overnight.</li>
                 <li>
                    The Hotel front desk requires all visitors to present a government approved photo
                    identity prior to accessing guest floors/rooms.
                 </li>
             </ol>
             <h5>Child Policy:</h5>
             <ol>
                 <li>
                    Stay of 1 child up to 5 years of age is complementary without the use of an extra
                    mattress. Breakfast charges may be applicable for the child.
                 </li>
             </ol>
             <h5>Code of Conduct:</h5>
             <ol>
                 <li>Illegal activities are not permitted in the Hotel.</li>
                 <li>You should be aware that the Hotel may refuse service or evict you</li>
                 <ol type ='a'>
                     <li>For refusal or failure to pay for accommodation,</li>
                     <li>If you act in a disorderly fashion as to disturb the peace of other guests,</li>
                     <li>If you destroy, damage, deface or threaten harm to hotel property or guests,</li>
                     <li>Any of your actions are deemed inappropriate by the Hotel.</li>
                 </ol>
                 <li>
                    Please keep the Hotel room in a good condition and maintain hygiene and
                    cleanliness. You may be held liable for any damage to Hotel assets (except normal
                    wear and tear).
                 </li>
             </ol>
             <h5>Smoking, Drugs and Alcohol</h5>
             <ol>
                 <li>
                 Smoking is prohibited in the Hotel.
                 </li>
                 <li>
                    Anyone found using or under the influence of illegal drugs or substances classified
                    under the Narcotic Drugs and Psychotropic Substances Act, 1985 will be reported to
                    the police and asked to leave the Hotel. Any evidence or suspicion of drug use at the
                    Hotel will also be reported immediately to the police.
                 </li>
                 <li>
                    Drinking alcohol is prohibited in all public areas including; in the Hotel’s lobby,
                    hallways, and parking areas of the Hotel. Please contact the Hotel Front Desk
                    regarding consumption of alcoholic
                 </li>
             </ol>
             <p>
                beverages within your room, without disturbing the discipline of the Hotel or other guests.
             </p>
             <h5>Contact Policies:</h5>
             <ol>
                 <li>
                    You may be contacted any time before your check-in date to confirm your arrival
                    status/arrival time through calls or messages. If the Hotel does not receive a
                    response from you after multiple attempts, your booking may be put on hold or
                    cancelled. The Hotel will reinstate your booking when you contact us back or make a
                    payment through our secure payment options, subject to availability.
                 </li>
                 <li>
                    As we continue to strive to improve our services, we may reach out to you for your
                    feedback on your experience through calls or messages.
                 </li>
                 <li>We might reach out to you for offers.</li>
             </ol>
             <h5>Safety and Security</h5>
             <ol>
                 <li>
                    For your own safety, please follow fire safety and emergency response procedures as
                    directed by Hotel staff.
                 </li>
                 <li>
                    Hotel are not liable for lost, misplaced, damaged or stolen valuables or belongings.
                 </li>
             </ol>
              
          </div>
          
          
          
        </Modal.Body>
        <Modal.Footer>
          <Button className='closeBtn' onClick={props.onHide}>Close</Button>
        </Modal.Footer>
      </Modal>
        </div>
    )
}

export default RulePolicies
